(function(app) {

    app.provider("queueEntryApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.getNotesForEntry = function (queueEntryId) {
                        return complianceHubApiGateway.getArray("/QueueEntries/" + queueEntryId + "/Notes/All");
                    };

                    service.getTransactionForQueueEntry = function(queueEntryId) {
                        return complianceHubApiGateway.get("/QueueEntries/" + queueEntryId + "/Transaction");
                    };

                    //TODO: Remove Later
                    service.reject = function(entry) {
                        return complianceHubApiGateway.put("/QueueEntries/" + entry.Id + "/Reject", entry);
                    };

                    service.updateQueueEntryStatus = function (entry) {
                        return complianceHubApiGateway.put("/QueueEntries/" + entry.Id, entry);
                    };

                    // POSTs

                    service.addQueueEntryNote = function (queueEntryId, note) {
                        return complianceHubApiGateway.post("/QueueEntries/" + queueEntryId + "/Notes", note);
                    };

                    // DELETEs

                    service.removeQueueEntryNote = function (queueEntryId, id) {
                        return complianceHubApiGateway.delete("/QueueEntries/" + queueEntryId + "/Notes/" + id);
                    };

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line